import { Instagram, Facebook, MapPin, Phone, Mail } from "lucide-react";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer 
      data-testid="footer"
      className="bg-dark-paper border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo & Description */}
          <div className="md:col-span-2">
            <img
              src="https://customer-assets.emergentagent.com/job_gym-rancagua/artifacts/vax34u1r_Logotipo%20Inspirion%20GYM%20v1_Alta%20Calidad.png"
              alt="Inspirion GYM"
              className="w-40 mb-4"
            />
            <p className="text-gray-400 text-sm leading-relaxed max-w-md">
              Tu gimnasio de entrenamiento personalizado en Rancagua. 
              Transforma tu cuerpo con acompañamiento real y planes diseñados para ti.
            </p>
            {/* Social Links */}
            <div className="flex gap-4 mt-6">
              <a 
                href="https://www.instagram.com/inspirion.gym?igsh=MW42OHpic3Z4bjE2NA==" 
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-white/5 hover:bg-neon-green/20 text-gray-400 hover:text-neon-green transition-colors"
                aria-label="Instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a 
                href="#" 
                className="w-10 h-10 flex items-center justify-center bg-white/5 hover:bg-neon-green/20 text-gray-400 hover:text-neon-green transition-colors"
                aria-label="Facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-bold uppercase tracking-wider text-sm mb-4">
              Enlaces
            </h4>
            <ul className="space-y-3">
              {[
                { label: "Inicio", href: "#" },
                { label: "Beneficios", href: "#beneficios" },
                { label: "Entrenamiento", href: "#entrenamiento" },
                { label: "Testimonios", href: "#testimonios" },
                { label: "Clase Gratis", href: "#clase-gratis" },
              ].map((link, index) => (
                <li key={index}>
                  <a 
                    href={link.href}
                    className="text-gray-400 hover:text-neon-green text-sm transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-bold uppercase tracking-wider text-sm mb-4">
              Contacto
            </h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3 text-gray-400 text-sm">
                <MapPin className="w-4 h-4 text-neon-green flex-shrink-0 mt-0.5" />
                <span>Av. Einstein 290, Of. 512<br />Rancagua, Chile</span>
              </li>
              <li className="flex items-center gap-3 text-gray-400 text-sm">
                <Phone className="w-4 h-4 text-neon-green flex-shrink-0" />
                <a href="tel:+56966951278" className="hover:text-neon-green transition-colors">
                  +56 9 6695 1278
                </a>
              </li>
              <li className="flex items-center gap-3 text-gray-400 text-sm">
                <Mail className="w-4 h-4 text-neon-green flex-shrink-0" />
                <a href="mailto:contacto@inspiriongym.cl" className="hover:text-neon-green transition-colors">
                  contacto@inspiriongym.cl
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-white/5 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-sm">
            © {currentYear} Inspirion GYM. Todos los derechos reservados.
          </p>
          <p className="text-gray-600 text-xs">
            Entrenamiento Personalizado en Rancagua
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
